import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import toast from "react-hot-toast";
import { ExpenseApiResponse, CreateExpenseRequest, UpdateExpenseRequest, ExpenseFilterDTO } from "./types/expenses";

export const useExpenses = () => {
  const queryClient = useQueryClient();
  const toastId = "expense-toast";

  // GET all expenses with filtering
  const Expenses = (filter: ExpenseFilterDTO, page: number = 0, size: number = 1000) => {
    return useQuery({
      queryKey: ["expenses", { filter, page, size }],
      queryFn: async () => {
        try {
          const response = await axios.post(`/api/v1/expenses/filter?page=${page}&size=${size}`, filter);
          return response.data as ExpenseApiResponse;
        } catch (error) {
          console.error("Error fetching expenses:", error);
          throw error;
        }
      },
      staleTime: 5 * 60 * 1000, // 5 minutes
    });
  };

  // POST create new expense
  const addExpense = useMutation({
    mutationFn: async (expense: CreateExpenseRequest) => {
      try {
        const response = await axios.post(`/api/v1/expenses/add_expenses`, expense);
        return response.data;
      } catch (error) {
        console.error("Error creating expense:", error);
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["expenses"] });
     // toast.success("Expense added successfully!");
     toast.success("Expense added successfully!", { id: toastId });
    },
    onError: (error: any) => {
      console.error("Error adding expense:", error);
      toast.error(error.response?.data?.message || "Failed to add expense");
    },
  });

  // GET expense by ID
  const getExpenseById = useMutation({
    mutationFn: async (id: string) => {
      try {
        const response = await axios.get(`/api/v1/expenses/getById/${id}`);
        return response.data;
      } catch (error) {
        console.error("Error fetching expense:", error);
        throw error;
      }
    },
  });

  // PUT update expense
  const updateExpense = useMutation({
    mutationFn: async ({ id, updatedExpense }: UpdateExpenseRequest) => {
      try {
        const response = await axios.put(`/api/v1/expenses/update_expenses/${id}`, updatedExpense);
        return response.data;
      } catch (error) {
        console.error("Error updating expense:", error);
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["expenses"] });
     // toast.success("Expense updated successfully!");
      toast.success("Expense updated successfully!", { id: toastId });
    },
    onError: (error: any) => {
      console.error("Error updating expense:", error);
      //toast.error(error.response?.data?.message || "Failed to update expense");
       toast.error(error.response?.data?.message || "Failed to update expense", { id: toastId });
    },
  });

  // DELETE expense
  const deleteExpense = useMutation({
    mutationFn: async (id: string) => {
      try {
        const response = await axios.delete(`/api/v1/expenses/delete_expenses/${id}`);
        return response.data;
      } catch (error) {
        console.error("Error deleting expense:", error);
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["expenses"] });
    //  toast.success("Expense deleted successfully!");
     toast.success("Expense deleted successfully!", { id: toastId });
    },
    onError: (error: any) => {
      console.error("Error deleting expense:", error);
     // toast.error(error.response?.data?.message || "Failed to delete expense");
      toast.error(error.response?.data?.message || "Failed to delete expense", { id: toastId });
    },
  });

 return {
  Expenses,
  addExpense, // mutation
  getExpenseById, // mutation
  updateExpense, // mutation (not updateExpenseMutation)
  deleteExpense, // mutation (not deleteExpenseMutation)
  queryClient,
};
};